import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=bdd5c0c0&scoped=true&"
import script from "./PricingView.vue?vue&type=script&lang=js&"
export * from "./PricingView.vue?vue&type=script&lang=js&"
import style0 from "./PricingView.vue?vue&type=style&index=0&id=bdd5c0c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd5c0c0",
  null
  
)

export default component.exports